import { EftWithdrawTransaction, TransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchEFTWithdrawTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  const [eftWithdrawTransaction, setEftWithdrawTransaction] = useState<EftWithdrawTransaction>();

  async function fetchEftWithdrawTransaction(params: TransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchEFTWithdrawTransaction(params, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setEftWithdrawTransaction(res);

      return res;
    } catch (error) {
      console.error(error);

      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, eftWithdrawTransaction, fetchEftWithdrawTransaction };
}
